export const SET_AUTH_INFO = 'setAuthInfo';
export const SET_AUTH_INFO_FIN = 'setAuthInfoFinalizacao';
export const INITIALIZE_FROM_COOKIES_AC = 'initFromCookies';
export const INITIALIZE_FROM_COOKIES_AC_FIN = 'initFromCookiesFinalizacao';
